module.exports = __webpack_public_path__ + "assets/img/center_icon12.5cd1905a.svg";